import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { loginModel } from 'src/app/Interface/login';
import { VwApiRequestsService, VW_ERROR_CODES } from 'vwappservices';
import { DataManipService } from 'src/app/services/data-sharing.service';
import { AuthService } from 'src/app/services/auth.service';
import { CurrentratesService } from 'src/app/default-layout/market-ticker/currentrates.service';
import { CommonServicesService } from 'src/app/services/common-services.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: false
})
export class LoginPageComponent implements OnInit {
  showPassword: boolean = false;
  errorEmployeeid: string = '';
  errorPassword: string = '';
  errorMsg: string = '';
  inputType: string = 'password';
  finYears: string[] = [];
  loginModel: loginModel = {
    loginid: '',
    password: '',
    clientkey: '',
    dType: 'W'
  };

  private vwApi = inject(VwApiRequestsService);
  private auth = inject(AuthService);
  private dataManipSrvc = inject(DataManipService);
  private toster = inject(ToastrService);
  private router = inject(Router);
  private commonSrvc = inject(CommonServicesService);
  private currentRatesService = inject(CurrentratesService);

  constructor(config: NgbCarouselConfig) {
    config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;

    if (location.origin === 'http://localhost:4200' || location.origin === 'http://localhost:5200') {
      this.loginModel.loginid = 'ketan';
      this.loginModel.password = 'admin@123';
    }
  }

  async ngOnInit(): Promise<void> {
    const res = await this.vwApi.postAPICall('user/getfinancialyears', {}, 'NONE');
    if (res.errorCode === VW_ERROR_CODES.SUCCESS) {
      this.finYears = res.Data || [];
      this.loginModel.clientkey = this.getCurrentIndianFinYear();
    }
  }

  private getCurrentIndianFinYear(): string {
    const now = new Date();
    const month = now.getMonth();
    const year = now.getFullYear();
    const startYear = month >= 3 ? year : year - 1;
    const target = `FY${startYear}-${String(startYear + 1).slice(2)}`;
    return this.finYears.includes(target) ? target : (this.finYears[0] || '');
  }

  login = async () => {
    this.auth.loginsignup(this.loginModel).subscribe(async (response) => {
      if (response.errorCode === VW_ERROR_CODES.SUCCESS) {
        const userInfo = response.Data?.userInfo;

        const [currentrates, paymentmodes, receiptmodes] = await Promise.all([
          this.commonSrvc.getCurrentRates(userInfo['branchid']),
          this.commonSrvc.getPaymentModes(),
          this.commonSrvc.getReceiptModes(),
          this.dataManipSrvc.loadFormatSettings()
        ]);

        userInfo['paymentmodes'] = paymentmodes;
        userInfo['receiptmodes'] = receiptmodes;
        this.dataManipSrvc.loginData = userInfo;
        this.dataManipSrvc.persistLoginData();
        document.title = `SDC [${this.loginModel.clientkey}]`;
        sessionStorage.setItem('clientkey', JSON.stringify(userInfo['clientkey']));
        this.currentRatesService.currentRates = currentrates;
        this.toster.success(response.errorDescription);
        this.router.navigateByUrl('/dashboard');
      } else {
        this.toster.error(response.errorDescription);
      }
    });
  };
}
